/* Concepto — motor de efecte + interacțiuni (homepage rebrand).
   Standalone, fără router (paginile Shopify sunt reale). Controlat din window.RB. */
(function () {
  var RB = window.RB || { cursor: true, intro: true, distortion: true };
  function ready(fn){ if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(function () {
    var d = document, body = d.body;
    var $ = function (s, c) { return (c || d).querySelector(s); };
    var $$ = function (s, c) { return Array.prototype.slice.call((c || d).querySelectorAll(s)); };
    var RM = matchMedia('(prefers-reduced-motion: reduce)').matches;
    var fine = matchMedia('(hover: hover) and (pointer: fine)').matches;
    var E = 'cubic-bezier(0.16,1,0.3,1)';
    var lock = function (on) { body.style.overflow = on ? 'hidden' : ''; };

    /* Cursor */
    if (RB.cursor && fine && !RM) {
      var cur = d.createElement('div'); cur.id = 'rb-cursor';
      var dot = d.createElement('div'); dot.id = 'rb-cursor-dot';
      body.appendChild(cur); body.appendChild(dot); body.classList.add('rb-cursor-on');
      var mx = innerWidth / 2, my = innerHeight / 2, cx = mx, cy = my;
      addEventListener('mousemove', function (e) { mx = e.clientX; my = e.clientY; dot.style.transform = 'translate(' + mx + 'px,' + my + 'px) translate(-50%,-50%)'; }, { passive: true });
      (function loop() { cx += (mx - cx) * 0.18; cy += (my - cy) * 0.18; cur.style.transform = 'translate(' + cx + 'px,' + cy + 'px) translate(-50%,-50%)'; requestAnimationFrame(loop); })();
      d.addEventListener('mouseover', function (e) { if (e.target.closest('a,button,[data-cursor]')) cur.classList.add('is-hover'); });
      d.addEventListener('mouseout', function (e) { if (e.target.closest('a,button,[data-cursor]')) cur.classList.remove('is-hover'); });
    }

    /* Intro */
    if (RB.intro && !RM && !sessionStorage.getItem('rb-intro-seen')) {
      sessionStorage.setItem('rb-intro-seen', '1');
      var intro = d.createElement('div'); intro.id = 'rb-intro';
      intro.innerHTML = '<div class="rb-intro__word">' + 'CONCEPTO'.split('').map(function (c) { return '<span>' + c + '</span>'; }).join('') + '</div><p class="rb-intro__sub">Atelier · București</p>';
      body.appendChild(intro);
      $$('.rb-intro__word span', intro).forEach(function (s, i) { s.style.transition = 'transform .9s ' + E; s.style.transitionDelay = (0.1 + i * 0.05) + 's'; requestAnimationFrame(function () { s.style.transform = 'none'; }); });
      var sub = $('.rb-intro__sub', intro); if (sub) { sub.style.transition = 'opacity .8s'; sub.style.transitionDelay = '.7s'; requestAnimationFrame(function () { sub.style.opacity = '1'; }); }
      setTimeout(function () { intro.style.transition = 'transform 1s ' + E; intro.style.transform = 'translateY(-100%)'; setTimeout(function () { intro.remove(); }, 1100); }, 1600);
    }

    /* Reveal pe scroll: gestionat acum de theme.js (IntersectionObserver),
       ca să existe un singur motor de scroll-reveal. */

    /* Magnetic */
    if (!RM && fine) $$('.magnetic').forEach(function (btn) {
      btn.addEventListener('mousemove', function (e) { var r = btn.getBoundingClientRect(); btn.style.transform = 'translate(' + ((e.clientX - (r.left + r.width / 2)) * 0.3) + 'px,' + ((e.clientY - (r.top + r.height / 2)) * 0.38) + 'px)'; });
      btn.addEventListener('mouseleave', function () { btn.style.transition = 'transform .5s ' + E; btn.style.transform = 'none'; setTimeout(function () { btn.style.transition = ''; }, 500); });
    });

    /* Header la scroll + back to top */
    var headers = $$('[data-rb-header]'), totop = $('.rb-totop');
    var onScroll = function () { headers.forEach(function (h) { h.classList.toggle('is-scrolled', scrollY > 50); }); if (totop) totop.classList.toggle('is-visible', scrollY > 600); };
    addEventListener('scroll', onScroll, { passive: true }); onScroll();
    if (totop) totop.addEventListener('click', function () { scrollTo({ top: 0, behavior: 'smooth' }); });

    /* Header adaptiv pe home (feedback Figma #2/#5): transparent peste hero,
       conținut alb; devine alb cu conținut negru după ce iese de pe imagine. */
    var overlayHeader = $('.rb-header--overlay');
    if (overlayHeader) {
      var heroEl = $('.rb-hero');
      var setPull = function () { overlayHeader.style.setProperty('--header-pull', -overlayHeader.offsetHeight + 'px'); };
      var onOverlayScroll = function () {
        var h = overlayHeader.offsetHeight;
        var limit = heroEl ? Math.max(heroEl.offsetHeight - h, 10) : 10;
        overlayHeader.classList.toggle('is-solid', scrollY > limit);
      };
      setPull(); onOverlayScroll();
      addEventListener('resize', function () { setPull(); onOverlayScroll(); });
      addEventListener('scroll', onOverlayScroll, { passive: true });
    }

    /* Sortare: închide dropdown-ul <details> la click oriunde în afara lui
       (cerere client 2026-07-21). */
    d.addEventListener('click', function (e) {
      $$('details.collection-toolbar__sort[open]').forEach(function (dt) {
        if (!dt.contains(e.target)) dt.removeAttribute('open');
      });
    });

    /* Distorsiune lichidă */
    if (RB.distortion && !RM) {
      var NS = 'http://www.w3.org/2000/svg';
      var svg = d.createElementNS(NS, 'svg'); svg.setAttribute('aria-hidden', 'true'); svg.style.cssText = 'position:absolute;width:0;height:0;overflow:hidden;pointer-events:none'; body.appendChild(svg);
      var n = 0;
      $$('[data-liquid]').forEach(function (el) {
        var inner = el.querySelector('img,.ph,canvas') || el; var id = 'rbliq' + (n++);
        var f = d.createElementNS(NS, 'filter'); f.setAttribute('id', id); f.setAttribute('x', '-12%'); f.setAttribute('y', '-12%'); f.setAttribute('width', '124%'); f.setAttribute('height', '124%'); f.setAttribute('color-interpolation-filters', 'sRGB');
        var t = d.createElementNS(NS, 'feTurbulence'); t.setAttribute('type', 'fractalNoise'); t.setAttribute('baseFrequency', '0.009 0.013'); t.setAttribute('numOctaves', '2'); t.setAttribute('seed', '4'); t.setAttribute('result', 'n');
        var dm = d.createElementNS(NS, 'feDisplacementMap'); dm.setAttribute('in', 'SourceGraphic'); dm.setAttribute('in2', 'n'); dm.setAttribute('scale', '0'); dm.setAttribute('xChannelSelector', 'R'); dm.setAttribute('yChannelSelector', 'G');
        f.appendChild(t); f.appendChild(dm); svg.appendChild(f); inner.style.filter = 'url(#' + id + ')';
        var scale = 0, target = 0, raf = null;
        var run = function () { scale += (target - scale) * 0.12; dm.setAttribute('scale', scale.toFixed(2)); if (Math.abs(target - scale) > 0.04) raf = requestAnimationFrame(run); else { scale = target; dm.setAttribute('scale', scale.toFixed(2)); raf = null; } };
        var kick = function () { if (!raf) raf = requestAnimationFrame(run); };
        if ('IntersectionObserver' in window) { var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { scale = 26; target = 0; kick(); io.unobserve(el); } }); }, { threshold: 0.18 }); io.observe(el); }
        el.addEventListener('mouseenter', function () { target = 11; kick(); });
        el.addEventListener('mousemove', function (e) { var r = el.getBoundingClientRect(); target = 8 + Math.abs((e.clientX - (r.left + r.width / 2)) / r.width) * 20; kick(); });
        el.addEventListener('mouseleave', function () { target = 0; kick(); });
      });
    }

    /* Scrollytelling */
    $$('[data-scrolly-stage]').forEach(function (stage) {
      var imgs = $$('.rb-scrolly__img', stage); var wrap = stage.closest('.rb-scrolly'); var steps = wrap ? $$('[data-scrolly-step]', wrap) : [];
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { var i = +e.target.getAttribute('data-scrolly-step'); imgs.forEach(function (im, j) { im.classList.toggle('is-active', j === i); }); } }); }, { threshold: 0.55, rootMargin: '-18% 0px -32% 0px' });
      steps.forEach(function (s) { io.observe(s); });
    });

    /* Drawers */
    /* #13 (2026-07-23): drawerele de meniu/căutare sunt randate ÎN secțiunea de
       header, iar sticky header-ul stă peste overlay (fix client 2026-07-21) —
       moștenind acel context de stivuire, overlay-ul (1080) ajungea PESTE
       conținutul drawerului → „overlay ciudat" la meniu/search pe mobil.
       Le mutăm ca frați în .rb (NU pe <body>: și-ar pierde variabilele CSS
       --bg/--ink din wrapperul [data-dir]) — exact cum coșul (.rb-cartd) e deja
       randat în afara headerului și funcționează corect. */
    var reparentDrawers = function () {
      var rbRoot = $('.rb');
      if (!rbRoot) return;
      ['.rb-menu', '.rb-searchd'].forEach(function (sel) {
        var all = $$(sel);
        if (!all.length) return;
        /* În editorul de teme secțiunea de header se re-randează și ar apărea
           duplicate: păstrăm exemplarul proaspăt (cel încă în secțiune). */
        var fresh = null;
        all.forEach(function (el) { if (!fresh && el.parentElement !== rbRoot) fresh = el; });
        if (!fresh) fresh = all[0];
        all.forEach(function (el) {
          if (el === fresh) return;
          // editor: dacă drawerul vechi era deschis când s-a re-randat secțiunea,
          // transferăm starea — altfel rămâne overlay activ + scroll blocat.
          if (el.classList.contains('is-open')) fresh.classList.add('is-open');
          el.remove();
        });
        if (fresh.parentElement !== rbRoot) rbRoot.appendChild(fresh);
      });
    };
    reparentDrawers();
    d.addEventListener('shopify:section:load', reparentDrawers);

    var overlay = $('.rb-overlay');
    var closeDrawers = function () { $$('.rb-menu,.rb-searchd,.rb-cartd,.rb-filterd').forEach(function (el) { el.classList.remove('is-open'); }); if (overlay) overlay.classList.remove('is-active'); lock(false); };
    var openDrawer = function (kind) { closeDrawers(); var map = { menu: '.rb-menu', search: '.rb-searchd', cart: '.rb-cartd', filters: '.rb-filterd' }; var el = $(map[kind]); if (!el) return; el.classList.add('is-open'); if (overlay) overlay.classList.add('is-active'); lock(true); if (kind === 'search') { var inp = $('input', el); if (inp) setTimeout(function () { inp.focus(); }, 400); } };

    /* Mega-menu desktop (butonul SHOP, ≥990px) — Figma 2026-07-14 */
    var mega = $('[data-mega]');
    var megaBtn = $('.rb-navbtn[data-open="menu"]');
    var megaMQ = matchMedia('(min-width: 990px)');
    var closeMega = function () { if (mega) { mega.classList.remove('is-open'); mega.setAttribute('hidden', ''); if (megaBtn) megaBtn.setAttribute('aria-expanded', 'false'); } };
    var openMega = function () { if (!mega) return; closeDrawers(); mega.classList.add('is-open'); mega.removeAttribute('hidden'); if (megaBtn) megaBtn.setAttribute('aria-expanded', 'true'); };
    if (mega && megaMQ.addEventListener) megaMQ.addEventListener('change', function (mq) { if (!mq.matches) closeMega(); });

    /* Închide panoul de localizare (folosit la click în afară / Escape) */
    var closeLocales = function () {
      $$('[data-locale].is-open').forEach(function (wrap) {
        wrap.classList.remove('is-open');
        var t = wrap.querySelector('[data-locale-toggle]'); if (t) t.setAttribute('aria-expanded', 'false');
      });
    };

    /* Submeniuri */
    $$('[data-submenu]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var item = btn.closest('.rb-menu__item');
        var was = item.classList.contains('is-open');
        $$('.rb-menu__item.is-open').forEach(function (i) {
          i.classList.remove('is-open');
          var t = i.querySelector('[data-submenu]'); if (t) t.setAttribute('aria-expanded', 'false');
        });
        if (!was) { item.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); }
      });
    });

    /* Accordion */
    $$('.rb-accordion').forEach(function (g) { $$('details', g).forEach(function (det) { det.addEventListener('toggle', function () { if (det.open) $$('details', g).forEach(function (o) { if (o !== det) o.open = false; }); }); }); });

    /* Grup meniu (SHOP −/+) */
    $$('[data-menu-group-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.closest('[data-menu-group]');
        if (!group) return;
        var open = group.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });

    /* Selector localizare (ROMÂNIA / RON ⌄) — feedback Figma #1 */
    $$('[data-locale-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var wrap = btn.closest('[data-locale]');
        if (!wrap) return;
        var open = wrap.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });

    /* Click delegat: drawers, wishlist, quick-add, FBT, qty */
    d.addEventListener('click', function (e) {
      if (!e.target.closest('[data-locale]')) closeLocales();
      var op = e.target.closest('[data-open]');
      if (op) {
        e.preventDefault();
        var kind = op.getAttribute('data-open');
        // Pe desktop, „SHOP" deschide mega-menu-ul, nu drawer-ul (Figma 2026-07-14)
        if (kind === 'menu' && mega && megaMQ.matches) { if (mega.classList.contains('is-open')) closeMega(); else openMega(); return; }
        closeMega();
        openDrawer(kind);
        return;
      }
      if (mega && mega.classList.contains('is-open') && !e.target.closest('[data-mega]')) closeMega();
      if (e.target.closest('[data-close]') || (overlay && e.target === overlay)) { closeDrawers(); }
      var w = e.target.closest('[data-wish]'); if (w) { e.preventDefault(); w.classList.toggle('is-active'); return; }
      // FBT/recomandări din sertar: add real prin theme.js ([data-sugg-add]). Aici nu mai falsificăm contorul.
    });
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeDrawers(); closeMega(); closeLocales(); } });
  });
})();
